import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./Pages/Login/Login";
import HomeLayout from "./Layouts/HomeLayout/HomeLayout";
import EmailSupport from "./Pages/Home/EmailSupport";
import Home from "./Pages/Home/Home";
import Meetings from "./Pages/Home/Meetings";
import SupportTickets from "./Pages/Support/SupportTickets";
import CreateOrUpdateTicket from "./Pages/Support/CreateOrUpdateTicket";
import CreateOrUpdateCompany from "./Pages/Company/CreateOrUpdateCompany";
import ManageCompanies from "./Pages/Company/ManageCompanies";
import LoginLayout from "./Layouts/LoginLayout/LoginLayout";
import ForgetPassword from "./Pages/Login/ForgetPassword";

export default function Router() {
  return (
    <Routes>
      <Route element={<HomeLayout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/email-support" element={<EmailSupport />} />
        <Route path="/meetings" element={<Meetings />} />
        <Route path="/support-tickets" element={<SupportTickets />} />
        <Route
          path="/support-tickets/create-ticket"
          element={<CreateOrUpdateTicket />}
        />
        <Route
          path="/support-tickets/edit-ticket/:ticket_id"
          element={<CreateOrUpdateTicket />}
        />
        <Route path="/create-company" element={<CreateOrUpdateCompany />} />
        <Route path="/manage-companies" element={<ManageCompanies />} />
        <Route
          path="/manage-companies/update-company/:company_id"
          element={<CreateOrUpdateCompany />}
        />
      </Route>
      <Route element={<LoginLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
      </Route>
    </Routes>
  );
}
